export default __webpack_public_path__ + "static/media/avatar.3bb5300c.svg";